import {createAction, CustomStoreAddOn, on, RemoteCollectionStore, StoreBuilder} from "@softline/core";
import {lastValueFrom} from "rxjs";
import {EmballageService} from "../services/emballage-service";
import {Kommissionierung, KommissionierungBewegung} from "../types/kommissionierung";

type State = RemoteCollectionStore.State<KommissionierungBewegung>;

const remoteCollectionStore = RemoteCollectionStore.create<KommissionierungBewegung>();

const mutations = {
}

const getters = {
}

const actions = {
  emballagenSchreiben: createAction<State, {idkopfbskomm: string, emballagen: KommissionierungBewegung[]}, Kommissionierung>('llrKommissionierungEmballage/actions/emballageHinzufuegen')
}

const LlrKommissionierungEmballageStoreExtension: CustomStoreAddOn<State, typeof mutations, typeof getters, typeof actions> = {
  mutations,
  getters,
  actions,
  feature: {
    getters: [
    ],
    actions: [
      on(actions.emballagenSchreiben, async ({ params, injector, commit, featureName }) => {
        const service = injector.get(EmballageService);

        const result =  await lastValueFrom(service.emballagenSchreiben(params.idkopfbskomm, params.emballagen));

        return result;
      })
    ],
    mutations: [
    ]
  },
}

export const LlrEmballageStore = new StoreBuilder(remoteCollectionStore)
  .add(LlrKommissionierungEmballageStoreExtension)
  .value;
